import React, { useState } from 'react';
import { Box, Select, Title, Group } from '@mantine/core';
import InternalPageLayout from '../Layout/InternalPageLayout';

export default function KnowledgeGraphPage() {
  const [selectedBatch, setSelectedBatch] = useState('batch_1.json');

  const dataOptions = [
    { value: 'batch_1.json', label: 'Batch 1: Buckingham Palace (Place)' },
    { value: 'batch_2.json', label: 'Batch 2: John F. Kennedy (Person)' },
    { value: 'batch_3.json', label: 'Batch 3: Random x15' },
    { value: 'batch_4.json', label: 'Batch 4: Marble House (Place)' },
    { value: 'batch_5.json', label: 'Batch 5: Random LoveFood x10' },
    { value: 'batch_6.json', label: 'Batch 6: New Orleans (Article Ideation)' }
  ];

  return (
    <InternalPageLayout>
      <Box p="md" style={{ height: 'calc(100vh - 60px)', display: 'flex', flexDirection: 'column' }}>
        <Group position="apart" mb="md">
          <Title order={2} style={{ color: '#e8edf5' }}>Epistemic Network Viewer</Title>
          <Select
            value={selectedBatch}
            onChange={setSelectedBatch}
            data={dataOptions}
            style={{ width: 300 }}
            variant="filled"
          />
        </Group>
        
        <Box style={{ flex: 1, borderRadius: '14px', overflow: 'hidden', border: '1px solid rgba(100, 140, 200, 0.14)' }}>
          <iframe 
            src={`/epistemic-viewer/index.html?data=${selectedBatch}`}
            style={{ width: '100%', height: '100%', border: 'none' }}
            title="Epistemic Knowledge Graph"
          />
        </Box>
      </Box>
    </InternalPageLayout>
  );
}